import { CreateLeadRequest } from "api"
import {
  Dispatch,
  FC,
  SetStateAction,
  createContext,
  useContext,
  useState,
} from "react"

export type CompaniesContextType = {
  companiesData: CreateLeadRequest
  setCompaniesData: Dispatch<SetStateAction<CreateLeadRequest>>
}

export const CompaniesContext = createContext<CompaniesContextType>(null)

export const CompaniesContextProvider: FC = ({ children }) => {
  const [companiesData, setCompaniesData] = useState<CreateLeadRequest>()
  return (
    <CompaniesContext.Provider value={{ companiesData, setCompaniesData }}>
      {children}
    </CompaniesContext.Provider>
  )
}

export const useCompaniesContext = () => useContext(CompaniesContext)
